<template>
  <div class="top-block">
    <div class="left">
      <share-block></share-block>
    </div>
    <div class="right">
      <a @click="$ga.event('Ссылка', 'Афиша', 1)" href="https://www.afisha.ru/"  target="_blank"><span class="afisha"></span></a>
    </div>
  </div>
</template>

<script>
    import ShareBlock from '@/components/ShareBlock.vue';

    export default {
        components: {
            ShareBlock
        },
        name: "TopBlock"
    }
</script>

<style scoped lang="scss">
  .top-block {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    .left {
      position: absolute;
      left: 22px;
      top: 19px;
    }
    .right {
      position: absolute;
      right: 19px;
      top: 17px;
    }

  }

  .afisha {
    display: block;
    width: 57px;
    height: 24px;
    background: url("../assets/img/afisha.png") no-repeat;
    background-size: contain;
  }

  @media screen and (min-width: 768px) {
    .top-block{
      width: 100%;
      height: 100%;
      .left{
        top: auto;
        bottom: 3.3vh;
        left: auto;
        right: 24px;
        z-index: 1000;

      }
    .right {
      position: absolute;
      right: 26px;
      top: 23px;
    }}
    .afisha {
      width: 75px;
      height: 30px;
      background: url("../assets/img/afisha-d.png") no-repeat;
      background-size: contain;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/TopBlock.vue